import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_API_FIELD_NAME } from './FormikEntityActionConfigFields.constants'

export function getFormikEntityActionConfigFieldsInitialValuesPayload(
  actionType
) {
  return actionType
    ? {
        [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_API_FIELD_NAME]:
          actionType.value,
      }
    : null
}
